module.exports = __webpack_public_path__ + "a809ec1f9ffd078c3f3a14c051fee810.png";